module.exports = __webpack_public_path__ + "static/paypal-a4bfca1a6a5b766f509d65075583ca58.png";